package linkerpangoquipdb

import kotlin.String

public data class SelectLastUserId(
  public val user_id: String?,
)
